<template>
    <div class="timeline-container">
        <div class="timeline-dates">
            <div
                v-for="stage in timelineStages"
                :key="`${stage.type}-date`"
                class="timeline-date"
            >
                {{ stage.date ? formatDate(stage.date) : "" }}
            </div>
        </div>

        <div class="timeline">
            <div
                v-for="stage in timelineStages"
                :key="stage.type"
                class="timeline-stage"
            >
                <div
                    v-if="stage.active"
                    class="timeline-stage-inner"
                    :class="stage.class"
                >
                    <span class="timeline-title">
                        {{ stage.title }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {timeUtils} from "../mixins/TimeUtils.js";

export default {
    name: "TimelineContainer",
    mixins: [timeUtils],
    props: {
        events: {
            type: Array,
            required: true
        }
    },

    computed: {
        timelineStages() {
            const createdEvent = this.findEvent("created");
            const assignedEvent = this.findEvent("assigned");
            const closedEvent = this.findEvent("closed");

            return [
                {
                    type: "created",
                    title: createdEvent?.title || "Luotu",
                    date: createdEvent?.date || null,
                    class: createdEvent?.class || null,
                    active: Boolean(createdEvent)
                },
                {
                    type: "assigned",
                    title: assignedEvent?.title || "Osoitettu",
                    date: assignedEvent?.date || null,
                    class: assignedEvent?.class || null,
                    active: Boolean(assignedEvent)
                },
                {
                    type: "closed",
                    title: closedEvent?.title || "Valmis",
                    date: closedEvent?.date || null,
                    class: closedEvent?.class || null,
                    active: Boolean(closedEvent)
                }
            ];
        }
    },

    methods: {
        findEvent(type) {
            if (!Array.isArray(this.events)) {
                return null;
            }

            return this.events.find(event => {
                return event?.type === type;
            }) || null;
        },

        formatDate(date) {
            return this.toLocalTime(date)
        }
    }
};
</script>

<style scoped>
.timeline-container {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding-top: .2em;
    overflow: hidden;
    border-radius: 0.3em;
    background: #f6f5f1;
}

.timeline-dates {
    display: flex;
    width: 100%;
    min-width: 0;
    margin-left: .2em;
    box-sizing: border-box;
}

.timeline-date {
    flex: 1 1 0;
    min-width: 0;
    padding-left: 0.3em;
    box-sizing: border-box;
    overflow: hidden;
    color: #052f5b;
    font-size: .75em;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.timeline {
    display: flex;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 0.15em;
}

.timeline-stage {
    flex: 1 1 0;
    min-width: 0;
    height: 1.7em;
    margin: 0.1em;
    padding: 0.1em;
    box-sizing: border-box;
    border-radius: 0.25em;
}

.timeline-stage-inner {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 0.2em;
}

.timeline-title {
    display: block;
    min-width: 0;
    overflow: hidden;
    color: #111111;
    font-weight: 500;
    line-height: 1.6em;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0.25em;
    padding-right: 0.25em;
}

@media (max-width: 600px) {
    .timeline-date {
        font-size: 10px;
    }

    .timeline-title {
        font-size: 12px;
    }
}
</style>
